<template>
  <el-card>
    <div slot="header" class="toolbar">
      <span>热门推荐信息</span>
      <div>
        <el-button v-if="$hasPermission('mall:hot-recommend:save')" type="primary" size="mini" @click="openCreate">新增推荐</el-button>
      </div>
    </div>

    <div class="search-bar search-wrap">
      <el-input v-model.trim="query.title" placeholder="请输入推荐标题" clearable style="width: 260px" @keyup.enter.native="handleSearch" />
      <el-button type="primary" @click="handleSearch">查询</el-button>
      <el-button @click="reset">重置</el-button>
    </div>

    <el-table :data="list" border style="width: 100%">
      <el-table-column prop="id" label="编号" width="90" />
      <el-table-column prop="goodsName" label="商品名称" min-width="180" />
      <el-table-column prop="title" label="展示标题" min-width="180" />
      <el-table-column label="展示图片" width="110">
        <template slot-scope="{ row }">
          <el-image
            :src="resolveFileUrl(row.imageUrl)"
            :preview-src-list="row.imageUrl ? [resolveFileUrl(row.imageUrl)] : []"
            fit="cover"
            class="table-image"
          >
            <div slot="error" class="table-image-error">无图</div>
          </el-image>
        </template>
      </el-table-column>
      <el-table-column prop="imageUrl" label="图片地址" min-width="240" show-overflow-tooltip />
      <el-table-column prop="sortNum" label="排序" width="90" />
      <el-table-column prop="status" label="状态" width="90">
        <template slot-scope="{ row }">
          {{ row.status === 1 ? '启用' : '禁用' }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="260" fixed="right">
        <template slot-scope="{ row }">
          <el-button v-if="$hasPermission('mall:hot-recommend:update')" size="mini" @click="openEdit(row)">编辑</el-button>
          <el-button
            v-if="$hasPermission('mall:hot-recommend:update')"
            :type="row.status === 1 ? 'warning' : 'success'"
            size="mini"
            @click="toggleStatus(row)"
          >
            {{ row.status === 1 ? '禁用' : '启用' }}
          </el-button>
          <el-button v-if="$hasPermission('mall:hot-recommend:delete')" size="mini" type="danger" @click="remove(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-bar">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="query.page"
        :page-size="query.limit"
        :page-sizes="[10, 20, 50, 100]"
        :total="total"
        @current-change="handlePageChange"
        @size-change="handleSizeChange"
      />
    </div>

    <el-dialog :title="form.id ? '编辑热门推荐' : '新增热门推荐'" :visible.sync="dialogVisible" width="720px" :close-on-click-modal="false">
      <el-form ref="formRef" :model="form" :rules="rules" label-width="90px">
        <el-form-item label="商品" prop="goodsId">
          <el-select v-model="form.goodsId" filterable style="width: 100%">
            <el-option v-for="item in goodsOptions" :key="item.id" :label="item.goodsName" :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="展示标题">
          <el-input v-model.trim="form.title" />
        </el-form-item>
        <el-form-item label="展示图片">
          <image-selector
            v-model="form.imageUrl"
            :category-code.sync="form.imageCategoryCode"
            :allowed-categories="['hot-recommend']"
          />
        </el-form-item>
        <el-form-item label="排序">
          <el-input v-model.number="form.sortNum" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button
          v-if="$hasPermission(form.id ? 'mall:hot-recommend:update' : 'mall:hot-recommend:save')"
          type="primary"
          @click="save"
        >
          保存
        </el-button>
      </span>
    </el-dialog>
  </el-card>
</template>

<script>
import http from '../../utils/http'
import { resolveFileUrl } from '../../utils/file'
import ImageSelector from '../../components/mall/ImageSelector.vue'

function defaultForm () {
  return {
    id: null,
    goodsId: null,
    title: '',
    imageUrl: '',
    imageCategoryCode: 'hot-recommend',
    sortNum: 0,
    status: 1
  }
}

function defaultQuery () {
  return {
    page: 1,
    limit: 10,
    title: ''
  }
}

export default {
  components: {
    ImageSelector
  },
  data () {
    return {
      query: defaultQuery(),
      total: 0,
      list: [],
      goodsOptions: [],
      dialogVisible: false,
      form: defaultForm(),
      rules: {
        goodsId: [{ required: true, message: '请选择商品', trigger: 'change' }]
      }
    }
  },
  created () {
    this.load()
    this.loadGoodsOptions()
  },
  methods: {
    resolveFileUrl,
    async load () {
      const { data } = await http.get('/mall/hot-recommend/list', { params: this.query })
      const pageData = data.data || {}
      this.list = pageData.list || []
      this.total = Number(pageData.total || 0)
    },
    async loadGoodsOptions () {
      const { data } = await http.get('/mall/goods/options')
      this.goodsOptions = data.data || []
    },
    handleSearch () {
      this.query.page = 1
      this.load()
    },
    handlePageChange (page) {
      this.query.page = page
      this.load()
    },
    handleSizeChange (limit) {
      this.query.limit = limit
      this.query.page = 1
      this.load()
    },
    reset () {
      this.query = defaultQuery()
      this.load()
    },
    openCreate () {
      this.form = defaultForm()
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.formRef && this.$refs.formRef.clearValidate()
      })
    },
    async openEdit (row) {
      const { data } = await http.get(`/mall/hot-recommend/info/${row.id}`)
      const info = data.data || {}
      this.form = {
        id: info.id,
        goodsId: info.goodsId,
        title: info.title || '',
        imageUrl: info.imageUrl || '',
        imageCategoryCode: 'hot-recommend',
        sortNum: info.sortNum || 0,
        status: info.status
      }
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.formRef && this.$refs.formRef.clearValidate()
      })
    },
    toggleStatus (row) {
      const nextStatus = row.status === 1 ? 0 : 1
      const actionText = nextStatus === 1 ? '启用' : '禁用'
      this.$confirm(`确定${actionText}热门推荐“${row.title || row.goodsName || '未命名'}”吗？`, '提示', { type: 'warning' }).then(async () => {
        const { data } = await http.post('/mall/hot-recommend/status', {
          id: row.id,
          status: nextStatus
        })
        if (data.code === 0) {
          this.$message.success(`热门推荐${actionText}成功`)
          this.load()
        }
      })
    },
    save () {
      this.$refs.formRef.validate(async valid => {
        if (!valid) return
        const payload = {
          id: this.form.id,
          goodsId: this.form.goodsId,
          title: this.form.title,
          imageUrl: this.form.imageUrl,
          sortNum: this.form.sortNum,
          status: this.form.status
        }
        const url = payload.id ? '/mall/hot-recommend/update' : '/mall/hot-recommend/save'
        const { data } = await http.post(url, payload)
        if (data.code === 0) {
          this.$message.success(payload.id ? '热门推荐修改成功' : '热门推荐新增成功')
          this.dialogVisible = false
          this.load()
        }
      })
    },
    remove (row) {
      this.$confirm('确定删除该热门推荐吗？', '提示', { type: 'warning' }).then(async () => {
        const { data } = await http.post('/mall/hot-recommend/delete', [row.id])
        if (data.code === 0) {
          this.$message.success('热门推荐删除成功')
          this.load()
        }
      })
    }
  }
}
</script>

<style scoped>
.toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.search-bar {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}

.search-wrap {
  flex-wrap: wrap;
}

.table-image {
  width: 64px;
  height: 64px;
  border-radius: 6px;
  border: 1px solid #ebeef5;
  cursor: pointer;
}

.table-image-error {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #c0c4cc;
  background: #f5f7fa;
}

.pagination-bar {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
}
</style>
